/*-----------------------------------------------------------------------------/
/ EXC delivery estimate
/
/ <delivery-estimate data-days="5" data-template="Guaranteed delivery by {date}">
/
/ Prints a delivery date counted from the shopper's own device clock, so the
/ date shown is in their timezone, not the store's, and it is formatted in
/ their locale (a UK shopper sees "Sat, 20 Sep", a US one "Sat, Sep 20").
/ Days and wording come from the Price block settings.
/
/ Rendered hidden and only shown once the date is in, so nobody ever sees the
/ raw {date} placeholder.
/ Notes: hq/projects/excdesigns/theme-build-notes.md
/-----------------------------------------------------------------------------*/
class DeliveryEstimate extends HTMLElement {
  // Locale data loading is the expensive part, so build the formatter once and
  // reuse it for every instance on the page rather than per element
  static #formatter;

  static #getFormatter() {
    if (!DeliveryEstimate.#formatter) {
      DeliveryEstimate.#formatter = new Intl.DateTimeFormat(undefined, {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      });
    }
    return DeliveryEstimate.#formatter;
  }

  connectedCallback() {
    const output = this.querySelector('[data-delivery-text]');
    const days = parseInt(this.dataset.days, 10);
    const template = this.dataset.template || '{date}';
    if (!output || isNaN(days)) return;

    const date = new Date();
    date.setDate(date.getDate() + days);

    let formatted;
    try {
      formatted = DeliveryEstimate.#getFormatter().format(date);
    } catch (e) {
      formatted = date.toDateString();
    }

    output.textContent = template.replace('{date}', formatted);
    this.hidden = false;
  }
}

if (!customElements.get('delivery-estimate')) {
  customElements.define('delivery-estimate', DeliveryEstimate);
}
